export default __webpack_public_path__ + "static/media/smallA.accd668a.svg";